import CoreuiController from "../lib/coreui-controller"
import OTPInput from "../coreui/otp_input"

export default class CoreuiOTPInputController extends CoreuiController {
  static Component = OTPInput
}
